import React, { createContext, useState } from 'react';

export const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [reservationSearchQuery, setReservationSearchQuery] = useState('');

  return (
    <SearchContext.Provider value={{ searchQuery, setSearchQuery, reservationSearchQuery, setReservationSearchQuery }}>
      {children}
    </SearchContext.Provider>
  );
};
